<template>
	<ManagingSection
		class="selected-participant-table"
		:isTable="true"
		:tableTitle="`당첨(대기)자 리스트 (총 ${totalWinnerCnt}명)`"
		:bodyScrollTable="true"
	>
		<template slot="topBar">
			<div class="selected-participant-table__top-bar">
				<div
					class="section__info__left"
					v-text="
						'* 당첨자 선정 완료처리가 된 유저는 파란색으로 표시됩니다. 당첨취소 시 유의해주세요.'
					"
				/>
				<div class="section__info__right">
					<button
						type="button"
						class="section__info__items btn"
						v-text="'Push 발송'"
						@click="sendingPush"
					/>
					<button
						type="button"
						class="section__info__items btn-excel"
						v-text="'엑셀 다운로드'"
						@click="downSpreadsheet"
					/>
				</div>
			</div>
			<ul
				v-if="winnerMappedPdtList.length > 1"
				class="event-winner-pick__select-list-tab"
			>
				<li
					v-for="item in winnerMappedPdtList"
					:key="item.idProduct"
					class="event-winner-pick__select-list-tab__list-item"
				>
					<label
						:class="[
							'event-winner-pick__select-list-tab__tab',
							'btn',
							{ selected: tabbedPdtId === item.idProduct },
						]"
					>
						<input
							v-model="tabbedPdtIdModel"
							:value="item.idProduct"
							type="radio"
							class="event-winner-pick__select-list-tab__input"
						/>
						{{ item.productName }} ({{ item.candidateCnt }}명)
					</label>
				</li>
			</ul>
		</template>
		<div slot="bodyScrollTable" class="body-scroll-table__wrap">
			<div class="body-scroll-table__thead-scroller">
				<table class="table-main selected-participant-table">
					<thead>
						<tr>
							<th>
								<button
									type="button"
									class="btn-delete--only-icon"
									@click="clickRemoveWinner(null)"
								/>
							</th>
							<th v-for="th in thList" :key="th" v-text="th" />
						</tr>
					</thead>
				</table>
			</div>
			<div
				class="body-scroll-table__tbody-scroller"
				@scroll="onListScroll"
			>
				<table class="table-main selected-participant-table">
					<tbody v-if="winnerMappedPdtList">
						<tr
							v-for="(item, idx) in slicedTabbedPdtWinnerList"
							:key="idx"
							:class="[
								'event-winner-pick__winner-table__row',
								{
									'history-item': item.originWinner,
									withdrawal:
										!item.isActivity && item.closedDate,
								},
							]"
						>
							<td>
								<button
									type="button"
									class="btn-delete--only-icon"
									@click="clickRemoveWinner(item.idRegister)"
								/>
							</td>
							<td>
								<RouterLink
									:to="`/register/register-info/${item.idRegister}`"
									target="_blank"
									class="link"
									>{{ item.idRegister }}</RouterLink
								>
							</td>
							<td>
								<RouterLink
									:to="`/register/register-info/${item.idRegister}`"
									target="_blank"
									class="link"
									>{{ item.nickName }}</RouterLink
								>
							</td>
							<td>{{ item.gender }}</td>
							<td>{{ item.age }}</td>
							<td>{{ item.skinType }}</td>
							<td>
								<button
									type="button"
									class="btn small"
									@click="
										$store.commit('modal/toggleModal', {
											id: 'ReviewerGrade',
											params: item.idRegister,
										})
									"
									v-text="'리뷰어'"
								/>
							</td>
							<td>{{ item.beautyProfile }}</td>
							<td>
								<a
									v-if="
										item.isExternalAdvertising &&
                                        item.externalAdvertising &&
										item.externalAdvertising.instagramUrl
									"
									:href="
										item.externalAdvertising.instagramUrl
									"
									target="_blank"
									class="link insta-link"
									v-text="'링크'"
								/>
							</td>
							<template v-if="item.answerList">
								<td
									v-for="(answer, idx) in item.answerList"
									class="selected-participant-table__img-td"
									:key="idx"
								>
									<ImageExif
										v-if="
											answer.applyType === 3 &&
											Array.isArray(answer.values)
										"
										:src="answer.values[0]"
										class="event-winner-pick__event-list-table__img"
										@click.native="
											viewOriginImg(item.idRegister)
										"
									/>
									<template v-else>{{
										answer.values.join() ||
										item.eventQuestionAnswer
									}}</template>
								</td>
							</template>
							<td v-else v-text="' - '" />
							<td>
								<p class="selected-participant-table__user-tel">
									<PhoneNumber :tel="item.userTel" />
									<span>
										<IsCertification
											:isCertification="
												item.isCertification
											"
										/>
									</span>
								</p>
							</td>
							<td>{{ item.fullAddr }}</td>
							<td>
								<i
									v-if="item.hasReview"
									class="event-winner-pick__event-list-table__true-icon fa fa-check-circle"
								/>
							</td>
							<td v-text="item.gradeTitle" />
							<td v-text="item.isPickple ? 'Y' : 'N'" />
							<td v-text="item.instaCate" />
							<td>
								<a
									v-if="item.eventMissionLink"
									:href="item.eventMissionLink"
									target="_blank"
									class="link mission-link"
									>링크</a
								>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</ManagingSection>
</template>
<script>
	import Util from '@/util.js';
	import { eventUserAnswerList } from '@/util.js';
	import compact from 'lodash/compact';
	import { mapState, mapGetters } from 'vuex';
	import { beautyProfileTypeList } from '@/constants.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ImageExif from '@/components/ImageExif.vue';
	import PhoneNumber from '@/components/Atoms/PhoneNumber.vue';
	import IsCertification from '@/components/Atoms/IsCertification.vue';

	export default {
		name: 'EventWinnerPickWinnerList',
		components: {
			ManagingSection,
			ImageExif,
			PhoneNumber,
			IsCertification,
		},
		props: {
			eventApplyData: {
				type: Array,
				default: () => [],
			},
			lastDetailsReqUrl: {
				type: String,
				default: '',
			},
			totalWinnerCnt: {
				type: Number,
				default: 0,
			},
			idEvent: {
				type: String,
				default: null,
			},
			winnerMappedPdtList: {
				type: Array,
				default: () => [],
			},
			tabbedPdtId: {
				type: Number,
				default: null,
			},
			originWinnerMappedPdtList: {
				type: Array,
				default: () => [],
			},
			eventTitle: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				offset: 0,
				limit: 100,
			};
		},
		computed: {
			...mapState('env', ['IMAGE_STORAGE_PATH']),
			...mapGetters({
				getItemById: 'getItemById',
			}),
			tabbedPdtIdModel: {
				get() {
					return this.tabbedPdtId;
				},
				set(v) {
					this.$emit('tabbedPdtId', v);
				},
			},
			tabbedPdt() {
				return this.winnerMappedPdtList.find(
					item => item.idProduct === this.tabbedPdtId
				);
			},
			tabbedPdtWinnerList() {
				return (this.tabbedPdt?.candidates || []).map(item => ({
					...item,
					answerList:
						this.eventApplyData.length && item.eventQuestionAnswer
							? eventUserAnswerList(
									item.eventQuestionAnswer,
									this.eventApplyData
								)
							: null,
				}));
			},
			thList() {
				return compact([
					'회원번호',
					'닉네임',
					'성별',
					'나이',
					'피부타입',
					'등급',
					'뷰티프로필',
					'인스타그램',
					'신청 정보 1',
					this.eventApplyData.length === 2 ? '신청 정보 2' : null,
					'휴대폰 번호',
					'주소',
					'리뷰 작성 여부',
					'회원 등급',
					'픽플 여부',
					'인스타 카테고리',
					'미션 제출 여부',
				]);
			},
			sliceLength() {
				return this.offset + this.limit;
			},
			slicedTabbedPdtWinnerList() {
				return this.tabbedPdtWinnerList.slice(0, this.sliceLength);
			},
		},
		methods: {
			sendingPush() {
				const targetList = this.tabbedPdtWinnerList;
				if (!targetList.length) {
					alert('당첨(대기)자 없습니다');
					return;
				}
				const idList = targetList.map(item => item.idRegister);
				localStorage.setItem('idList', idList);
				window.open(
					`${this.$router.resolve({ name: 'PushSend' }).href}`,
					'_blank'
				);
			},
			groupByBeautyProfileType(idList) {
				return beautyProfileTypeList.map(item =>
					idList
						? compact(
								idList.split(',').map(id => item.idMap[id])
							).join(' / ')
						: ''
				);
			},
			downSpreadsheet() {
				const originList = this.originWinnerMappedPdtList;
				const list = this.winnerMappedPdtList;

				// DB에 저장된 유저 리스트 정보가 없을 경우
				if (originList.every(item => !item.candidates.length)) {
					alert('선택된 참여자가 없습니다.');
					return;
				}

				// DB에 저장된 유저 리스트 정보가 있지만, DB에 저장되기 전의 변경값이 있을 경우 (일부 유저 선택추가/해제 후 저장하지 않은 상태)
				const noSaveUser = !originList.every((item, idx) => {
					const originWinnerList = item.candidates;
					const winnerList = list[idx].candidates;
					return originWinnerList.length !== winnerList.length
						? false
						: originWinnerList.every(originWinner =>
								winnerList.some(
									winner =>
										originWinner.idRegister ===
										winner.idRegister
								)
							);
				});

				if (noSaveUser) {
					alert(
						'변경된 참여자 정보가 있습니다. 먼저 "임시저장" 또는 "당첨자 선정 완료"를 해주세요.'
					);
					return;
				}

				const rows = this.tabbedPdtWinnerList.map(item => {
					const eventAnswerValue = item?.answerList?.map(
						item =>
							item.values.join() ||
							item.eventQuestionAnswer ||
							'-'
					);

					return [
						item.idRegister,
						item.nickName,
						item.userName,
						item.gender,
						item.age,
						item.skinType,
						...this.groupByBeautyProfileType(
							item.beautyProfileIdList
						),
						item.externalAdvertising?.instagramUrl,
						this.eventApplyData.length > 0 && item.answerList
							? eventAnswerValue[0]
							: '-',
						this.eventApplyData.length > 0 && item.answerList
							? eventAnswerValue[1]
							: '-',
						() => `="${item.userTel}"`,
						!item.isActivity && item.closedDate
							? 'null'
							: `${item.userAddress} ${item.userAddressMore}`,
						item.hasReview ? 'Y' : 'N',
						() => `="${item.userZipcode}"`,
						item.gradeTitle,
						item.isPickple ? 'Y' : 'N',
						item.instaCate,
						item.eventMissionLink,
					];
				});
				const productName = this.tabbedPdt.productName;
				const title = `${this.eventTitle}${productName ? `_${productName}` : ''}`;
				const fileName = `이벤트당첨자리스트_${title}_${new Date().getTime()}`;
				Util.getCsv(
					[rows],
					[title],
					[
						[
							'회원번호',
							'닉네임',
							'이름',
							'성별',
							'나이',
							'피부타입',
							...beautyProfileTypeList.map(({ type }) => type),
							'인스타그램',
							'신청정보1',
							'신청정보2',
							'휴대폰 번호',
							'주소',
							'리뷰작성여부',
							'우편번호',
							'회원 등급',
							'픽플 여부',
							'인스타 카테고리',
							'미션 제출여부',
						],
					],
					fileName,
					this.lastDetailsReqUrl
				);
			},
			clickRemoveWinner(idRegister) {
				const winnerMappedPdtList = this.winnerMappedPdtList;
				const payload = {
					pdtIdList: [this.tabbedPdtId],
					removeIdList: compact([idRegister]),
				};
				const confirmMsg = idRegister
					? '해당 참여자를 선택 해제하시겠습니까?'
					: `참여자 ${this.tabbedPdt.candidateCnt}명을 선택 해제하시겠습니까?`;

				if (!confirm(confirmMsg)) return;

				const removeIdList = idRegister
					? [idRegister]
					: this.tabbedPdtWinnerList.map(item => item.idRegister);

				const isMultipleEventRegister = removeIdList.some(
					item =>
						winnerMappedPdtList.filter(({ candidates }) =>
							candidates.some(item3 => item3.idRegister === item)
						).length > 1
				);

				const removeWinner = this.$parent.removeWinner;

				if (isMultipleEventRegister) {
					this.$store.commit('modal/toggleModal', {
						id: 'SelectProductForEventWinnerRemove',
						params: {
							removeIdList,
							winnerMappedPdtList,
							removeWinner,
						},
					});
				} else {
					removeWinner(payload);
				}
			},
			async viewOriginImg(idRegister) {
				const url = `/api/event/candidate/${this.idEvent}/${idRegister}/images`;
				try {
					const { data } = await this.$axiosAdmin2.get(url);
					await Util.popupImages(
						data.map(item => `${this.IMAGE_STORAGE_PATH}${item}`),
						500
					);
				} catch (err) {
					console.error(err);
					alert(
						'등록된 이미지 불러오기를 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			onListScroll(e) {
				if (
					this.sliceLength < this.tabbedPdtWinnerList.length &&
					e.target.scrollTop / e.target.scrollHeight > 0.9
				) {
					this.offset += this.limit;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.selected-participant-table {
		&__top-bar {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.event-winner-pick__select-list-tab {
			width: 100%;
			float: left;
			margin-left: -6px;
		}

		.event-winner-pick__select-list-tab__list-item {
			display: inline-block;
			margin: 6px;
		}

		.event-winner-pick__select-list-tab__tab {
			width: auto;
			font-size: 0.875rem;

			&.selected {
				border: solid 1px $btn-blue;
				color: #fff;
				background: $btn-blue;
			}
		}

		.event-winner-pick__select-list-tab__input {
			display: none;
		}

		.selected-participant-table__img-td {
			position: relative;
		}

		.event-winner-pick__event-list-table__img {
			cursor: pointer;
			position: absolute;
			display: block;
			width: auto;
			height: 100%;
			top: 0;
			left: 0;
		}

		.event-winner-pick__event-list-table__true-icon {
			color: $green;
			font-size: 1.375rem;
		}

		.event-winner-pick__winner-table__row.history-item {
			background: rgba($font-blue, 0.4);
		}

		.event-winner-pick__winner-table__row.withdrawal {
			background: rgba($red, 0.4);
		}

		.body-scroll-table__thead-scroller,
		.body-scroll-table__tbody-scroller {
			min-width: 1200px;
		}

		.body-scroll-table__tbody-scroller {
			max-height: 360px;
		}

		.selected-participant-table__user-tel {
			display: flex;
			flex-direction: column;
		}

		.insta-link,
		.mission-link {
			word-break: break-all;
		}
	}
</style>
